import PageMenu from "../../../components/custom/app/pageMenu/pageMenu";
import Button from "@mui/material/Button";
import {Link, useHistory} from "react-router-dom";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PageContentWrapper from "../../../components/mui/general/pageContentWrapper/pageContentWrapper";
import PageTitle from "../../../components/mui/app/pageTitle/pageTitle";
import Box from "@mui/material/Box";
import {useTranslation} from "react-i18next";
import {REGISTRATIONS} from "../locales/namespaces";
import {useEffect, useState} from "react";
import {withPermissionHOC} from "../../permission/components/permissionHOC/permissionHOC";
import {access_registrations} from "../../../helpers/rights";
import useMobileIndex from "../hooks/useMobileIndex";
import SkeletonLoaderWrapper from "../../../components/mui/general/skeletonLoaderWrapper/skeletonLoaderWrapper";
import dayjs from "dayjs";
import {getRouteUrl} from "../../../helpers/routing/getRouteUrl";
import {ROUTE_PAGE_NEW_REGISTRATION_EDIT, ROUTE_PAGE_REGISTRATION_EDIT} from "../routes/routes";
import ClearIcon from "@mui/icons-material/Clear";
import Grid from "@mui/material/Grid2";
import {FormControl, FormHelperText, FormLabel, useMediaQuery, useTheme} from "@mui/material";
import {formControlDefaults} from "../../../helpers/theme/defaultProps";
import CustomAutocomplete from "../../../components/mui/form/autocomplete/autocomplete";
import {ErrorMessage, useFormik} from "formik";
import {DatePicker} from "@mui/x-date-pickers-pro";
import axios from "axios";
import useUserData from "../../../hooks/user/useUserData";
import {API} from "../../../helpers/constants";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors} from "../../../helpers/errorHandling";

const MobileIndex = () => {
    const { token, roles } = useUserData()
    const { t } = useTranslation(REGISTRATIONS);
    const history = useHistory()
    const {loading,indexData} = useMobileIndex()
    const [sortDesc, setSortDesc] = useState(true); // true = πιο πρόσφατη πρώτα
    const [sortedData, setSortedData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [filters, setFilters] = useState({
        project: null,
        foreman: null,
        workDt: null
    });
    const [projectsData, setProjectsData] = useState([]);
    const [usersData, setUsersData] = useState([]);
    const [loadingSearch, setLoadingSearch] = useState(false)
    const [clearRequested, setClearRequested] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const STORAGE_KEY = 'MobileIndex_filters_snapshot_v1';

    useEffect(() => {
        try {
            const saved = sessionStorage.getItem(STORAGE_KEY);
            if (!saved) return;

            const parsed = JSON.parse(saved);
            // restore filters
            setFilters({
                project: parsed.filters?.project ?? null,
                foreman: parsed.filters?.foreman ?? null,
                workDt: parsed.filters?.workDt ? dayjs(parsed.filters.workDt) : null
            });

            // restore sort order if present
            if (typeof parsed.sortDesc === 'boolean') {
                setSortDesc(parsed.sortDesc);
            }

            // restore lists
            if (Array.isArray(parsed.originalData)) {
                setOriginalData(parsed.originalData);
            }
            if (Array.isArray(parsed.sortedData)) {
                setSortedData(parsed.sortedData);
            }
        } catch (e) {
            console.warn('Could not restore snapshot', e);
        } finally {

        }
    }, []); // run once on mount

    useEffect(() => {
        document.title = t('Registrations List')
        const saved = sessionStorage.getItem(STORAGE_KEY);
        if (!saved) {
            handleSearch()
        }
    }, [])

    useEffect(() => {
        if (clearRequested) {
            handleSearch();
            setClearRequested(false);
        }
    }, [filters, clearRequested]);

    useEffect(() => {
        axios.get(`${API}/en/fts/project/work/create`,  {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }).then(res => {
            setProjectsData(res.data.projects || []);
            setUsersData(res.data.foremen || []);
        }).catch(err => {
            console.error('Dropdown load error:', err);
        });
    }, []);

    const handleSearch = () => {
        const data = {};
        if (filters.project) data.ProjectId = filters.project.id;
        if (filters.foreman) data.Foreman = filters.foreman.id;
        if (filters.workDt) data.WorkDt = dayjs(filters.workDt).format('YYYY-MM-DD');

        axios.post(`${API}/en/fts/project/work/index`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }).then(res => {
            console.log('result',res.data.result)
            if(res.data.result.length === 0 ){
                enqueueSnackbar( t('Data not found!'), {
                    variant: 'warning',
                    autoHideDuration: 3000,
                })
            }
            const fetched = res.data.result || [];

            setOriginalData(fetched);
            setSortedData(
                [...fetched].sort((a, b) => {
                    const aDate = a.WorkDt && dayjs(a.WorkDt).isValid() ? dayjs(a.WorkDt) : dayjs(0);
                    const bDate = b.WorkDt && dayjs(b.WorkDt).isValid() ? dayjs(b.WorkDt) : dayjs(0);
                    return sortDesc
                        ? bDate.diff(aDate)
                        : aDate.diff(bDate);
                })
            );
        }).catch(err => {
            console.error('Search error:', err);
        });
    };

    const handleClear = () => {
        setFilters({ project: null, foreman: null, workDt: null });
        sessionStorage.removeItem(STORAGE_KEY);
        setClearRequested(true);
    };

    const toggleSort = () => {
        const newSortOrder = !sortDesc;
        setSortDesc(newSortOrder);
        const sorted = [...sortedData].sort((a, b) =>
            newSortOrder
                ? dayjs(b.WorkDt).diff(dayjs(a.WorkDt)) // φθίνουσα
                : dayjs(a.WorkDt).diff(dayjs(b.WorkDt)) // αύξουσα
        );
        setSortedData(sorted);
    };

    const handleSearch1 = (evt, name) => {
        let url
        let setter
        let foreman
        switch (name) {
            case 'projectsData':
                url = `${API}/en/fts/project/search`
                setter = setProjectsData
                foreman = 0
                break
            case 'usersData':
                url = `${API}/en/fts/project/user/search`
                setter = setUsersData
                foreman = 1
                break
            default:
                break
        }
        setLoadingSearch(true)
        axios({
            method: 'post',
            data: { 'query': evt.target.value, isForeman: foreman },
            url: url,
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        }).then((response) => {
            if (response.data.result.length > 0) {
                setter(response.data.result)
            }
            setLoadingSearch(false)
        }).catch((error) => {
            enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
                variant: 'warning',
                autoHideDuration: 3000,
            })
            setLoadingSearch(false)
        })
    }


    return(
        <SkeletonLoaderWrapper loading={loading}>
        <Box className={'registrations_index'} sx={{ marginTop: '10px',pt: !isMobile && 2 }}>
            <PageMenu>
                <Button
                    component={Link}

                    to={'/new-registration'}
                    startIcon={<AddCircleOutlineIcon/>}
                >
                    {t('Add')}
                </Button>

            </PageMenu>
            <PageContentWrapper>
                <Box display="flex" justifyContent={'space-between'} alignItems={'center'}  gap={2}>
                    <PageTitle
                        title={t('Registrations')}/>
                    <Box  mb={1}>
                        <Button size={'small'} color="secondary" variant="outlined" onClick={toggleSort}>
                            {t('Sort')} {sortDesc ? '↑' : '↓'}
                        </Button>
                    </Box>
                </Box>
                <Grid
                    container
                    spacing={2}
                    sx={{ marginLeft: '0px',mt:1,mb:1 }}
                >
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>

                            <FormLabel>{t('Project')}</FormLabel>
                            <CustomAutocomplete
                                 identifier={'id'}
                                options={projectsData}
                                value={filters.project}
                                onChange={(e, value) => setFilters(prev => ({ ...prev, project: value }))}
                                labelKey={'Description'}
                                onInputChange={(event) => handleSearch1(event, 'projectsData')}
                                otherprops={{
                                    handleHomeEndKeys: true
                                }}
                            />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>

                            <FormLabel>{t('Foreman')}</FormLabel>
                            <CustomAutocomplete
                                 identifier={'id'}
                                 options={usersData}
                                 value={filters.foreman}
                                 onChange={(e, value) => setFilters(prev => ({ ...prev, foreman: value }))}
                                 labelKey={'Description'}
                                onInputChange={(event) => handleSearch1(event, 'usersData')}
                                otherprops={{
                                    handleHomeEndKeys: true
                                }}

                            />

                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>

                            <FormLabel >{t('WorkDt')}</FormLabel>

                            <DatePicker
                                key={filters.workDt ? dayjs(filters.workDt).format('DD/MM/YYYY') : 'empty'}
                                sx={{ width: '100%' }}
                                slotProps={{
                                    textField: {
                                        //size: 'small',
                                        variant: 'standard',
                                    }
                                }}
                                name="WorkDt"
                                views={['year', 'month', 'day']}
                                //inputFormat={'DD/MM/YYYY'}
                                value={filters.workDt}
                                onChange={(newValue) => setFilters(prev => ({ ...prev, workDt: newValue }))}
                                format={'DD/MM/YYYY'}
                            />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 12 }} >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                            }}
                        >
                            <Button size={'small'} onClick={handleSearch} variant="contained">{t('Search')}</Button>
                            <Button size={'small'} onClick={handleClear} variant="contained" color={'error'}>{t('Clear')}</Button>
                        </Box>

                    </Grid>
                </Grid>

                {sortedData.map((item) => (
                    <Box
                        key={item.id}
                        // onClick={()=>history.push(getRouteUrl(ROUTE_PAGE_NEW_REGISTRATION_EDIT, { registrationId: item.id }))}
                        onClick={() => {
                            try {
                                const toSave = {
                                    filters: {
                                        project: filters.project,
                                        foreman: filters.foreman,
                                        workDt: filters.workDt ? dayjs(filters.workDt).format('YYYY-MM-DD') : null

                                    },
                                    sortDesc,
                                    originalData,
                                    sortedData
                                };
                                sessionStorage.setItem(STORAGE_KEY, JSON.stringify(toSave));
                            } catch (e) {
                                console.warn('Could not save snapshot', e);
                            }
                            history.push(getRouteUrl(ROUTE_PAGE_NEW_REGISTRATION_EDIT, { registrationId: item.id }));
                        }}

                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            p: 1.5,
                            mb: 1,
                            border: '1px solid #ddd',
                            borderRadius: 2,
                            backgroundColor: '#fafafa',
                            boxShadow: 1,
                            gap: 1,
                        }}
                    >
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            {/* Γραμμή 1: Περιγραφή */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: 0.5,
                                    maxWidth: '100%',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    color: '#304674',
                                }}
                            >
                                <Box>{item.Description}--{item.Foreman}</Box>
                            </Box>

                            {/* Γραμμή 2: Υπόλοιπα */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 1,
                                    justifyContent: 'flex-start',
                                }}
                            >
                                {/* Ημερομηνία */}
                                <Box sx={{ display: 'flex', gap: 0.5, color: '#304674' }}>
                                    <Box sx={{ fontWeight: 'bold' }}>{t('Date')}:</Box>
                                    <Box>{dayjs(item.WorkDt).format('DD/MM/YYYY')}</Box>
                                </Box>

                                {/* Ώρες Εργασίας */}
                                <Box sx={{ display: 'flex', gap: 0.5 }}>
                                    <Box sx={{ fontWeight: 'bold' }}>{t('Work Times')}:</Box>
                                    <Box>{item.WorkTm}h</Box>
                                </Box>

                                {/* Extra Ώρες */}
                                <Box sx={{ display: 'flex', gap: 0.5 }}>
                                    <Box sx={{ fontWeight: 'bold' }}>{t('Ext Hour')}:</Box>
                                    <Box>{item.ExtraWorkTm}h</Box>
                                </Box>
                            </Box>
                        </Box>


                        {/*/!* Μία γραμμή που σπάει σε δύο αν δεν χωράει *!/*/}
                        {/*<Box*/}
                        {/*    sx={{*/}
                        {/*        display: 'flex',*/}
                        {/*        flexWrap: 'wrap',*/}
                        {/*        gap: 2,*/}
                        {/*        justifyContent: 'space-between',*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    /!* Περιγραφή *!/*/}
                        {/*    <Box*/}
                        {/*        sx={{*/}
                        {/*            display: 'flex',*/}
                        {/*            gap: 0.5,*/}
                        {/*            //minWidth: '200px',*/}
                        {/*            maxWidth: '100%',*/}
                        {/*            whiteSpace: 'nowrap',*/}
                        {/*            overflow: 'hidden',*/}
                        {/*            textOverflow: 'ellipsis',*/}
                        {/*            color: '#304674'*/}
                        {/*        }}*/}
                        {/*    >*/}
                        {/*        /!*<Box sx={{ fontWeight: 'bold' }}>{t('Description')}:</Box>*!/*/}
                        {/*        <Box>{item.Description}</Box>*/}
                        {/*    </Box>*/}

                        {/*    /!* Ημερομηνία *!/*/}
                        {/*    <Box sx={{ display: 'flex', gap: 0.5,color: '#304674'}}>*/}
                        {/*        <Box sx={{ fontWeight: 'bold' }}>{t('Date')}:</Box>*/}
                        {/*        <Box>{dayjs(item.WorkDt).format('DD/MM/YYYY')}</Box>*/}
                        {/*    </Box>*/}

                        {/*    /!* Ώρες Εργασίας *!/*/}
                        {/*    <Box sx={{ display: 'flex', gap: 0.5 }}>*/}
                        {/*        <Box sx={{ fontWeight: 'bold' }}>{t('Work Time')}:</Box>*/}
                        {/*        <Box>{item.WorkTm}h</Box>*/}
                        {/*    </Box>*/}

                        {/*    /!* Extra Ώρες *!/*/}
                        {/*    <Box sx={{ display: 'flex', gap: 0.5 }}>*/}
                        {/*        <Box sx={{ fontWeight: 'bold' }}>{t('Extra Work Time')}:</Box>*/}
                        {/*        <Box>{item.ExtraWorkTm}h</Box>*/}
                        {/*    </Box>*/}
                        {/*</Box>*/}
                    </Box>
                ))}

            </PageContentWrapper>
        </Box>
            </SkeletonLoaderWrapper>
    )
}
export default withPermissionHOC(MobileIndex, [access_registrations])